import module from 'nominas/finiquito/module.js'
import template from './template.html'

export class NominasFiniquitoEscenarioDocumentosFiniquitoComponent {
  idProyecto
  idColaborador
  idFiniquito
  idEscenario
  url = null

  generar () {
    this.url = '/api/nominas/finiquitos/finiquito/escenarios/escenario/documentos/finiquito' +
      '?id_proyecto=' + this.idProyecto +
      '&id_colaborador=' + this.idColaborador +
      '&id_finiquito=' + this.idFiniquito +
      '&id_escenario=' + this.idEscenario
  }
}

module.component('nominasFiniquitoEscenarioDocumentosFiniquito', {
  controller: NominasFiniquitoEscenarioDocumentosFiniquitoComponent,
  template,
  bindings: {
    idProyecto: '<',
    idColaborador: '<',
    idFiniquito: '<',
    idEscenario: '<',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/finiquito/components/escenario/documentos/finiquito/component.js